import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextField, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import APIService from '../services/APIService';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    },
});

class OrganisationAdder extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: props.open,

            name: '',
            email: '',
            password: '',
        };
    }

    reset() {
        this.setState({
            name: '',
            email: '',
            password: '',
        });
    }

    add() {
        const { name, email, password} = this.state;
        let data = { name, email, password};
        APIService.storeOrganisation(data)
            .then((organisation) => {
                if (organisation) {
                    /**
                     * Instead of calling the API to retrieve user of this new organisation
                     * just dress the object here and return it back to master view
                     */
                    organisation.user = { email };

                    this.reset();

                    if (this.props.onAdded)
                        this.props.onAdded(organisation);
                }
            });
    }

    validate() {
        return this.state.name.length &&
                this.state.email &&
                this.state.password.length > 5;
    }

    render() {
        const { classes } = this.props;

        return (
            <Modal
                open={this.props.open}
                onClose={this.props.onClose}
            >
                <div className={classes.paper}>
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <Typography variant="title">{this.props.t('Lisää organisaatio')}</Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={this.props.t('Organisaation nimi')}
                                value={this.state.name}
                                required
                                onChange={(event) => this.setState({name: event.target.value})}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={this.props.t('Sähköposti')}
                                value={this.state.email}
                                required
                                onChange={(event) => this.setState({email: event.target.value})}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                type="password"
                                label={this.props.t('Salasana')}
                                value={this.state.password}
                                required
                                onChange={(event) => this.setState({password: event.target.value})}
                                error={this.state.password.length > 1 && this.state.password.length < 6 ? 'true' : ''}
                                helperText={this.state.password.length > 1 && this.state.password.length < 6 ? 'Salasanan tulee olla vähintään 6 merkkiä pitkä' : ''}
                            />
                        </Grid>


                        <Grid item xs={12} style={{textAlign: 'right'}}>
                            <Button
                                color="primary"
                                disabled={this.validate() == false}
                                onClick={() => this.add()}
                            >
                                {this.props.t('Lisää')}
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </Modal>
        );
    }
}

OrganisationAdder.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(OrganisationAdder));



// WEBPACK FOOTER //
// ./resources/assets/js/components/OrganisationAdder.js